import { render, staticRenderFns } from "./OpportunityDetail.vue?vue&type=template&id=e3861170"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports